import React, { useState } from "react";
import { AppConfig, PanelConfig } from "../../types/config";
import config from "../../config/config.json";
import { ToggleSwitch } from "./ToggleSwitch";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import { PanelConfigUIProps } from "../../types/config";

const appConfig = config as AppConfig;
export const panelConfigs: PanelConfig[] = appConfig.panelConfigs;
export const PanelConfigUI: React.FC<PanelConfigUIProps> = ({
  panelCollapseDirections,
  onCollapseDirectionChange,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleOpen} aria-label="settings">
        <SettingsIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div style={{ padding: "10px", minWidth: "150px" }}>
          <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
            {appConfig.settingsSummary}
          </div>
          {panelConfigs.map((cfg) => {
            const isHorizontal = cfg.defaultSplit === "h";
            const current = panelCollapseDirections[cfg.id];
            const isOn = isHorizontal ? current === "down" : current === "right";
            const onLabel = isHorizontal ? "D" : "R";
            const offLabel = isHorizontal ? "U" : "L";
            const toggle = () => {
              const newDirection = isOn
                ? isHorizontal
                  ? "up"
                  : "left"
                : isHorizontal
                  ? "down"
                  : "right";
              onCollapseDirectionChange(cfg.id, newDirection);
            };
            return (
              <div
                key={cfg.id}
                style={{
                  margin: "5px 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ marginRight: "10px", width: "100px" }}>
                  {cfg.label}:
                </span>
                <ToggleSwitch
                  isOn={isOn}
                  onToggle={toggle}
                  onLabel={onLabel}
                  offLabel={offLabel}
                />
              </div>
            );
          })}
        </div>
      </Menu>
    </div>
  );
};

export default appConfig;
